import React, { useEffect } from "react";
import Instructions from "../auth/onboarding/Instructions";

const InstructionsLanding = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <section className="exam-date-section ribbon-right ribbon-left">
      <div className="w-full h-full flex justify-center">
        <div className="detail-section instructions-sectio mb-20 -mt-5">
          <Instructions />
        </div>
      </div>
    </section>
  );
};

export default InstructionsLanding;
